import { render, staticRenderFns } from "./AdminBuildingTypeEditModal.vue?vue&type=template&id=085c47d9&"
import script from "./AdminBuildingTypeEditModal.vue?vue&type=script&lang=js&"
export * from "./AdminBuildingTypeEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports